import React, { useState, useEffect  } from 'react'
import useApiCallHooks from '../../hooks/useApiCallHooks';
import { apiRoutes } from '../../routes/api/apiRoutes';
import { FaRegUser } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';

const ForgetPassword = () => {
    const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

    const [data, setData] = useState({
        email: ""
    });


    const handelSubmit = (e) => {
        e.preventDefault();
        callAPI("post", apiRoutes.auth.login, data);
    }

    if (responce && responce?.data?.data?.token) {
        localStorage.setItem('udata', btoa(JSON.stringify(responce.data)));
    }
    return (
        <div className='sh-login position-relative'>
            <img
                src="/assets/img/others/h8_about_img_shape.svg"
                alt="shape"
                className="alltuchtopdown"
            />

            <img
                src="/assets/img/others/h8_about_img_shape.svg"
                alt="shape"
                className="alltuchtoptop"
            />
            <div className='row align-items-center ' >
                <div className='col-md-12 col-lg-8 form-swiper-col'>
                    <div className='form-swiper' >
                        <Swiper navigation={true} loop={true} autoplay={{delay: 2500,disableOnInteraction: false,}} modules={[Navigation, Autoplay]} className="myLoginSwiper">
                            <SwiperSlide className='swiper-img'>
                                <img src={"images/shubham/school-login-img.jpg"} alt='' className='swiper-slide-img'  />
                            </SwiperSlide>
                            <SwiperSlide className='swiper-img'>
                                <img src={"images/shubham/collage-login-img.jpg"} alt='' className='swiper-slide-img'  />
                            </SwiperSlide>
                            <SwiperSlide className='swiper-img'>
                                <img src={"images/shubham/school-login-img.jpg"} alt='' className='swiper-slide-img'  />
                            </SwiperSlide>
                        </Swiper>

                        
                    </div>

                </div>
                <div className='col-md-12 col-lg-4'>
                    <div className='sh-login-icon-div '>
                        <img src={"/images/sys-white-logo.png"} alt='' /> 
                        <h6 className='login-heading'>Forget Password</h6>
                        <h6 className='login-sub-heading'>Securely sign back in</h6>
                        </div>

                    <form onSubmit={handelSubmit} className='sh-form  p-3 p-md-4 '>
                        <div className="input-group mb-4">
                            <input type="text" className="form-control" placeholder='Enter Email' onChange={(e)=>setData({...data, email:e.target.value})} value={data.email}  />
                            <span className="input-group-text"><FaRegUser /></span>
                        </div>
                        <div className='text-center' >
                            <button type="submit" className="btn rounded bg-white text-dark m-0 mt-4 w-50">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ForgetPassword
